import React from "react";
import cx from "classnames";
import Transition, { ENTERED, ENTERING } from "react-transition-group/Transition";

const fadeStyles = {
  [ENTERING]: "in",
  [ENTERED]: "in",
};

function ModalTransition(props) {
  const { className, children, ...otherProps } = props;
  return (
    <Transition {...otherProps}>
      {(status, innerProps) =>
        React.cloneElement(children, {
          ...innerProps,
          className: cx("fade", className, children.props.className, fadeStyles[status]),
        })
      }
    </Transition>
  );
}

ModalTransition.defaultProps = {
  in: false,
  timeout: 300,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
};

export default ModalTransition;
